import { setDefaults } from 'react-i18next';

export const getNHLLogoURL = (teamId: string): string => {
  const baseUrl =
    'https://firebasestorage.googleapis.com/v0/b/data-tech-bb3f7.appspot.com/o/nhl';
  return `${baseUrl}${encodeURIComponent(`/logos/${teamId}.png`)}?alt=media`;
};
